// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1uaIZ","text":"SelectPayment_text__2EP5d","title":"SelectPayment_title__25mo1","btn":"SelectPayment_btn__2oLks"};